import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { paths } from "config/paths";
import { useWebRouter } from "~utils/next-router/use-web-router";

import { PortalActionCard } from "~ui-components/components/molecules/portal-action-card";

import { ItemCard } from "./items/item-card";

import { DataViewProps } from ".";

export function DataPortalMediumView(props: DataViewProps) {
	const router = useWebRouter();

	const {
		isLoading,
		items,
		onItemDelete,
		isImportDataAllowed,
		isDeleteDataAllowed,
	} = props;

	return (
		<Box
			sx={{
				display: "grid",
				gap: 4,
				gridTemplateColumns: {
					xs: "1fr",
					sm: "repeat(2, 1fr)",
					md: "repeat(3, 1fr)",
				},
			}}>
			{isImportDataAllowed && (
				<PortalActionCard
					title="import Data"
					href={paths.accountName.data.import(router._query.accountName)}
				/>
			)}
			{isLoading && (
				<Box sx={{ p: 2 }}>
					<CircularProgress />
				</Box>
			)}
			{Array.from(items.values()).map((item) => (
				<ItemCard
					size="medium"
					item={item}
					key={item.id}
					onDelete={onItemDelete}
					isDeleteDataAllowed={isDeleteDataAllowed}
				/>
			))}
		</Box>
	);
}
